export const normalizeCouponData = (couponResponse) => {
  return {
    ...couponResponse,
    discount_type: couponResponse?.type,
    expiry_date: couponResponse?.dateExpires,
    maximum_amount: Infinity,
    minimum_amount: 0,        
    maximum_discount: null    
  };
};
